export default __webpack_public_path__ + "static/media/Recreation_Logotipo vetorizado_V2_COLOR.9160178c.svg";